<template>
	<div style="background-color: #fafafa;">
		<van-nav-bar left-text="返回"  left-arrow @click-left="onClickLeft"></van-nav-bar>
		<van-tabs v-model="selected" type="card" color="#1890ff" sticky swipeable @click="switchTab">
			<van-tab title="领用出库">
				<div class="psiConfirmCont">
					<div style="display: flex;">
						<van-field-acb
								class="fieldLi"
								v-model="orderId"
								dict="vsheet_rad_dealer_order.serialNumber"
								label="领用单号"
								on-change=""
						>
						</van-field-acb>
					</div>
					<div style="display: flex;">
						<van-field
								v-model="outValue"
								center
								clearable
								label="领用条码"
								ref="outBarcodeInput"
								placeholder="请输入条码"
						>
							<template #button>
								<van-button size="small" type="info" @click="outConfirm"
								>确定</van-button
								>
							</template>
						</van-field>
					</div>
					<div class="psiDetailCont">
						<van-pull-refresh v-model="outRefreshing" @refresh="onOutRefresh">
							<van-list
									v-model="outLoading"
									:finished="outFinished"
									@load="onOutLoad"
									finished-text="没有更多了"
							>
								<div v-for="item in outList" class="card" :key="item.uuid">
									<template>
										<table class="layout">
											<tr>
												<td>{{ item.barcode }}</td>
												<td colspan="2">{{ item.statusname }}</td>
											</tr>
											<tr v-for="obj in item.details" :key="obj.field1">
												<td>{{obj.field1}}</td>
												<td>{{obj.field2}}</td>
												<td>{{obj.field3}}</td>
											</tr>
										</table>
									</template>
								</div>
							</van-list>
						</van-pull-refresh>
					</div>
				</div>
			</van-tab>
			<van-tab title="报废出库">
				<div class="psiConfirmCont">
					<div>
						<van-field
								v-model="value"
								center
								clearable
								autofocus
								label="条码"
								ref="discardBarcodeInput"
								placeholder="请输入条码"
						>
							<template #button>
								<van-button size="small" type="info" @click="confirm"
								>确定</van-button>
							</template>
						</van-field>
					</div>
					<div class="psiDetailCont">
						<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
							<van-list
									v-model="loading"
									:finished="finished"
									@load="onLoad"
									finished-text="没有更多了"
							>
								<div v-for="item in list" class="card" :key="item.uuid">
									<template>
										<table class="layout">
											<tr>
												<td>{{ item.barcode }}</td>
												<td colspan="2">{{ item.statusname }}</td>
											</tr>
											<tr v-for="obj in item.details" :key="obj.field1">
												<td>{{obj.field1}}</td>
												<td>{{obj.field2}}</td>
												<td>{{obj.field3}}</td>
											</tr>
										</table>
									</template>
								</div>
							</van-list>
						</van-pull-refresh>
					</div>
				</div>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import {
		Tab,
		Tabs,
		Panel,
		Button,
		List,
		Search,
		Popup,
		PullRefresh,
		NavBar,
		Stepper,
		Checkbox,
		CheckboxGroup,
		Toast, Field
	} from 'vant';
	import barcodeService from "../../service/barcodeService";
	import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
	import VanFieldAcb from "../../components/VanFieldAcb";
	export default {
		data() {
			return {
				selected: 0,
				value: "",
				tempValue: "",
				barcodeIds: ["0"],
				outValue: "",
				outTempValue: "",
				outBarcodeIds: ["0"],
				orderId: "",
				tempOrderId: "",
				list: [],
				outList: [],
				loading: false,
				outLoading: false,
				finished: false,
				outFinished: false,
				pageIndex: 0,
				outPageIndex: 0,
				refreshing: false,
				outRefreshing: false,
				fields:[],
				outFields:[],
				dictNames: "",
				outDictNames: "",
			};
		},
		components: {
			VanFieldAcb,
			[VanFieldAcb.name]: VanFieldAcb,
			[Field.name]: Field,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Button.name]: Button,
			[PullRefresh.name]: PullRefresh,
			[Panel.name]: Panel,
			[List.name]: List,
			[Search.name]: Search,
			[Popup.name]: Popup,
			[Stepper.name]: Stepper,
			[NavBar.name]: NavBar,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
		},
		mounted:  function () {
			//this.$refs.outBarcodeInput.focus();
			let that = this;
			document.onkeydown = function(event) {
				if (event.keyCode == 13) {
					if(that.selected === 0){
						that.outTempValue = that.outValue;
						if (that.outValue.length == 0) {
							that.$refs.outBarcodeInput.focus();
						} else {
							that.outConfirm();
						}
					}else{
						that.tempValue = that.value;
						if (that.value.length == 0) {
							that.$refs.discardBarcodeInput.focus();
						} else {
							that.confirm();
						}
					}
				}
			};
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1);
			},
			async confirm() {
				let resp = await barcodeService.discardBarcode(this.value);
				if (resp.data.Status === "1") {
					this.barcodeIds.push(resp.data.Data);
					Toast.success("报废成功");
					this.value = "";
					this.$refs.discardBarcodeInput.focus();
					this.onRefresh();
				} else {
					Toast.fail(resp.data.Message);
					this.value = "";
					this.$refs.discardBarcodeInput.focus();
				}
			},

			async onLoad() {
				if(this.dictNames == ""){
					let resp = await barcodeService.getBarcodeFieldList();
					if (resp.data.Status == "1") {
						this.fields = resp.data.Data;
						if(this.fields.length > 0){
							let tempDict = "position.rad_position";
							this.fields.forEach(item => {
								if(item.type == "6"){
									tempDict += ",";
									tempDict += item.name;
									tempDict+= ".";
									tempDict += item.dictName;
								}
							});
							tempDict += ",";
							tempDict += "status";
							tempDict+= ".";
							tempDict += "rad_barcode_status";
							this.dictNames = tempDict;
						}else{
							this.dictNames = "radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method,position.rad_position";
						}
					}
				}
				this.pageIndex++;
				let resp = await barcodeService.getInputList(
						this.pageIndex,
						this.barcodeIds.join(","),
						this.dictNames
				);
				resp.data.Data.data.forEach(item => {
					item.inputTime = moment(item.inputTime).format("YYYY-MM-DD");
				});
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				resp.data.Data.data.forEach(item => {
					let details = [];
					if(this.fields.length > 0){
						let length = this.fields.length;
						let detailItem = {};
						this.fields.forEach(function (obj, i) {
							if(obj.name == "pieces"){
								item[obj.name] = (item[obj.name] || "") + "片";
							}
							if(i%3 == 0){
								detailItem = {};
								if(obj.type == "6"){
									detailItem.field1 = item[obj.name+"name"] || "";
								}else{
									detailItem.field1 = item[obj.name] || "";
								}
								if(i == length -1){
									details.push(detailItem);
								}
							}
							if(i%3 == 1){
								if(obj.type == "6"){
									detailItem.field2 = item[obj.name+"name"] || "";
								}else{
									detailItem.field2 = item[obj.name] || "";
								}
								if(i == length -1){
									details.push(detailItem);
								}
							}
							if(i%3 == 2){
								if(obj.type == "6"){
									detailItem.field3 = item[obj.name+"name"] || "";
								}else{
									detailItem.field3 = item[obj.name] || "";
								}
								details.push(detailItem);
							}
						});
					}else{
						details.push({
							field1: item.radCategoryname,
							field2: item.radIdname,
							field3: item.pieces + "片"
						});
						details.push({
							field1: item.centerCategoryname,
							field2: item.centerSpacing,
							field3: item.calibername
						});
						details.push({
							field1: item.colorname,
							field2: item.waterFlowname,
							field3: item.isSpecials || ""
						});
					}
					item.details = details;
				});
				this.loading = false;
				this.refreshing = false;
				this.list = [...this.list, ...resp.data.Data.data];
				this.finished = resp.data.Data.total <= this.list.length;
			},
			onRefresh() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},

			async outConfirm() {
				let resp = await barcodeService.fetchOutBarcode(this.outValue, this.orderId);
				if (resp.data.Status === "1") {
					this.outBarcodeIds.push(resp.data.Data);
					Toast.success("领用成功");
					this.outValue = "";
					this.$refs.outBarcodeInput.focus();
					this.onOutRefresh();
				} else {
					Toast.fail(resp.data.Message);
					this.outValue = "";
					this.$refs.outBarcodeInput.focus();
				}
			},

			async onOutLoad() {
				if(this.outDictNames == ""){
					let resp = await barcodeService.getBarcodeFieldList();
					if (resp.data.Status == "1") {
						this.outFields = resp.data.Data;
						if(this.outFields.length > 0){
							let tempDict = "position.rad_position";
							this.outFields.forEach(item => {
								if(item.type == "6"){
									tempDict += ",";
									tempDict += item.name;
									tempDict+= ".";
									tempDict += item.dictName;
								}
							});
							tempDict += ",";
							tempDict += "status";
							tempDict+= ".";
							tempDict += "rad_barcode_status";
							this.outDictNames = tempDict;
						}else{
							this.outDictNames = "radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method,position.rad_position";
						}
					}
				}
				this.outPageIndex++;
				let resp = await barcodeService.getInputList(
						this.outPageIndex,
						this.outBarcodeIds.join(","),
						this.outDictNames
				);
				resp.data.Data.data.forEach(item => {
					item.inputTime = moment(item.inputTime).format("YYYY-MM-DD");
				});
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				resp.data.Data.data.forEach(item => {
					let details = [];
					if(this.outFields.length > 0){
						let length = this.outFields.length;
						let detailItem = {};
						this.outFields.forEach(function (obj, i) {
							if(obj.name == "pieces"){
								item[obj.name] = (item[obj.name] || "") + "片";
							}
							if(i%3 == 0){
								detailItem = {};
								if(obj.type == "6"){
									detailItem.field1 = item[obj.name+"name"] || "";
								}else{
									detailItem.field1 = item[obj.name] || "";
								}
								if(i == length -1){
									details.push(detailItem);
								}
							}
							if(i%3 == 1){
								if(obj.type == "6"){
									detailItem.field2 = item[obj.name+"name"] || "";
								}else{
									detailItem.field2 = item[obj.name] || "";
								}
								if(i == length -1){
									details.push(detailItem);
								}
							}
							if(i%3 == 2){
								if(obj.type == "6"){
									detailItem.field3 = item[obj.name+"name"] || "";
								}else{
									detailItem.field3 = item[obj.name] || "";
								}
								details.push(detailItem);
							}
						});
					}else{
						details.push({
							field1: item.radCategoryname,
							field2: item.radIdname,
							field3: item.pieces + "片"
						});
						details.push({
							field1: item.centerCategoryname,
							field2: item.centerSpacing,
							field3: item.calibername
						});
						details.push({
							field1: item.colorname,
							field2: item.waterFlowname,
							field3: item.isSpecials || ""
						});
					}
					item.details = details;
				});
				this.outLoading = false;
				this.outRefreshing = false;
				this.outList = [...this.outList, ...resp.data.Data.data];
				this.outFinished = resp.data.Data.total <= this.outList.length;
			},
			onOutRefresh() {
				this.outFinished = false;
				this.outLoading = true;
				this.outPageIndex = 0;
				this.outList = [];
				this.onOutLoad();
			},

			switchTab(index) {
				window.scrollTo(0, 0);
				this.selected = index;
				this.value = "";
				this.outValue = "";
				if(index === 0){
					this.onOutRefresh();
				}else{
					this.onRefresh();
				}
			},
		}
	}
</script>

<style scoped>
	.psiConfirmCont {
		width: 100%;
		margin: 0 auto;
		overflow: hidden;
	}

	.psiDetailCont {
		width: 100%;
		margin: 0 auto;
		margin-top: 20px;
	}
</style>
